/*Off canvas menu script */
function openNavLeft() {
    document.getElementById("offCanvas").style.top = "0";
}
function closeNavLeft() {
    document.getElementById("offCanvas").style.top = "-100%";
}
/*Off canvas menu script*/
/* FOR MEGA MENU */
jQuery(document).ready(function() {
  //Checks if li has sub (ul) and adds class for toggle icon - just an UI
  jQuery('.menu > ul > li > ul:not(:has(ul))').addClass('normal--sub');
  //Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)
  	
  	//Adds class to li of mega menu on hover
  	jQuery('.mega-menu > ul > li').mouseenter(function(){
	    jQuery(this).addClass('activate');
	});
	jQuery('.mega-menu > ul > li').mouseleave(function(){
	    jQuery(this).removeClass('activate');
	});
	
	//Ensures that when hovering on demo button or site logo, menu does NOT dim
	jQuery('.mega-menu > ul > li.menu__button--cta, .mega-menu > ul > li.site__menu--logo').mouseenter(function() {
		jQuery('.mega-menu > ul > li').addClass('deactivate');
	});
	jQuery('.mega-menu > ul > li.menu__button--cta, .mega-menu > ul > li.site__menu--logo').mouseleave(function() {
		jQuery('.mega-menu > ul > li').removeClass('deactivate');
	});
	
  	//Targets the menu items li
	jQuery(".mega-menu > ul > li").mouseenter(function(e) {
	//Checks the browser window width
	if (jQuery(window).width() > 943) {
	//Fades in the menu drawer
	  jQuery(this).children("ul").stop().fadeIn(200);
	  //Adds class to apply animation on mouse enter
	  jQuery(".mega-menu__col--icon, .basic__list--item").addClass("menuItemAnimation");
	  e.preventDefault();
	}
	});
	//Targets the menu items li
	jQuery(".mega-menu > ul > li").mouseleave(function(e) {
	//Checks the browser window width	
	if (jQuery(window).width() > 943) {
	//Fades out the menu drawer	
	  jQuery(this).children("ul").stop().fadeOut(200);
	  //Removes class that applies animation on mouse leave
	  jQuery(".mega-menu__col--icon, .basic__list--item").removeClass("menuItemAnimation");
	  e.preventDefault();
	}
	});
	
	/* ADDS DROPDOWN ARROW IF PARENT HAS CHILDREN */
	jQuery(function() {
	    jQuery('.mega-menu__topbar a').each(function() {
	        if ( jQuery(this).parent('li').children('ul').size() > 0 ) {
	            jQuery(this).addClass('mega-menu__hasdropdown');
	        }
	    });
	});
	/* ADDS DROPDOWN ARROW IF PARENT HAS CHILDREN */
	//Search form hide/show on click
	jQuery("#searchBarIcon").click(function(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    jQuery('.menu__search--form').fadeToggle(200);
	});
	jQuery('.menu__search--form').click(function(e) {
	  	e.stopPropagation();  
    });
	jQuery(document).click(function() {
	    jQuery('.menu__search--form').fadeOut(200);
	});
	//Search form hide/show on click
	// Show/Hide search bar mobile
	jQuery('.search__form--wrapper > .menu__search--form').click(function(e){
	    e.stopPropagation();
	});
	jQuery(".search__icon").click(function(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    jQuery('.search__form--wrapper > .menu__search--form').fadeToggle(300);
	});
	jQuery(document).click(function() {
	    jQuery('.search__form--wrapper > .menu__search--form').fadeOut(300);
	});
	// Show/Hide search bar mobile
	//Show/Hide buttons in blog sub nav
	jQuery(window).scroll(function(){
		if(jQuery(this).scrollTop()>10) {
			jQuery('#blogDemoCTA').addClass('sub-menu__show');
			jQuery('#blogDemoCTA').removeClass('sub-menu__hide');
		} else if (jQuery(this).scrollTop()<=1) {
			jQuery('#blogDemoCTA').removeClass('sub-menu__show');
			jQuery('#blogDemoCTA').addClass('sub-menu__hide');
		}
	});

	jQuery(window).scroll(function() {
		if(jQuery(this).scrollTop()>70) {
			jQuery('.sub-menu').addClass('fixed');
		} else if(jQuery(this).scrollTop()<=1) {
			jQuery('.sub-menu').removeClass('fixed');
		}
	});
	jQuery('.archive__menu--wrapper').hover(function() {
		jQuery('.topic__menu').toggleClass('menu__open');
	});
	//Navigation sticky toggle on scroll
	//Mobile Menu sticky toggle on scroll
	jQuery(window).scroll(function() {
		if(jQuery(this).scrollTop()>0) {
			jQuery('#top-bar-menu').addClass('fixed');
		} else if(jQuery(this).scrollTop()<=0) {
			jQuery('#top-bar-menu').removeClass('fixed');
		}
	});
	//Mobile Menu sticky toggle on scroll

	//Announcement bar swiper
	 (function($){
      jQuery( document ).ready(function() {
       if ( jQuery('.announcement__bg .swiper-slide').hasClass('swiper-slide-active') ) {

         var bg_color = jQuery('.announcement__bg .swiper-slide.swiper-slide-active').attr('data-slide-bg');
         jQuery('.announcement__bg').attr('style', bg_color);

       }
     });
    })(jQuery);

    swiper.on('slideChangeTransitionStart', function () {
        (function($){
        var bg_color = jQuery('.swiper-slide-active').attr('data-slide-bg');
				jQuery('.announcement__bg').attr('style', bg_color);
        })(jQuery);
	});
	//Announcement bar swiper
	
	jQuery('a[href^="https://twitter.com"]').mouseenter(function() {
		jQuery('.bird').addClass('bounce');
	}),
	jQuery('a[href^="https://twitter.com"]').mouseleave(function() {
		jQuery('.bird').removeClass('bounce');
	});
	//copy link success message
	jQuery('.copylink__button').click(function(){
		jQuery('.copylink__alert').slideDown(200).delay( 600 ).fadeOut(400);
	});

});

//Copy link function
(function() {

    'use strict';
  
  // click events
  document.body.addEventListener('click', copy, true);

    // event handler
    function copy(e) {

	    // find target element
	    var 
	      t = e.target,
	      c = t.dataset.copytarget,
	      inp = (c ? document.querySelector(c) : null);
	      
	    // is element selectable?
	    if (inp && inp.select) {
	      
	      // select text
	      inp.select();
	
	      try {
	        // copy text
	        document.execCommand('copy');
	        inp.blur();
	        
	      }
	      catch (err) {
	        alert('please press Ctrl/Cmd+C to copy');
	      }
	      
	    }
    
    }

	})
();
//Copy link function

//Smooth scroll
jQuery('a[href^="#"]').on('click', function(e) {
  e.preventDefault()

  jQuery('html, body').animate(
    {
      scrollTop: jQuery(jQuery(this).attr('href')).offset().top,
    },
    500,
    'swing'
  )
});
//Smooth scroll
